import type { MaterialMobileState, PendingShip } from "~/store/materialMobileSlice";

import wsId from "~/helpers/wsId";

type LegacyPendingShip = Omit<PendingShip, "shipActionKey"> & Partial<Pick<PendingShip, "shipActionKey">>;

const readLegacyShipKey = (shipInput: LegacyPendingShip["shipInput"]): string | undefined => {
	const legacyKey = (shipInput as { idempotentKey?: unknown }).idempotentKey;
	return typeof legacyKey === "string" && legacyKey.length > 0 ? legacyKey : undefined;
};

const backfillShipActionKey = (pendingShip: LegacyPendingShip): PendingShip =>
	pendingShip.shipActionKey
		? (pendingShip as PendingShip)
		: { ...pendingShip, shipActionKey: readLegacyShipKey(pendingShip.shipInput) ?? wsId() };

const migrateLegacyPendingShips = (outboundState: MaterialMobileState): MaterialMobileState => ({
	...outboundState,
	pendingShips: Object.fromEntries(
		Object.entries((outboundState.pendingShips ?? {}) as Record<string, LegacyPendingShip>).map(
			([movementOrderId, pendingShip]) => [movementOrderId, backfillShipActionKey(pendingShip)]
		)
	)
});

export default migrateLegacyPendingShips;
